export default {
    roundToPrecision: function (n, precision = 2) {
        return Math.round(n * Math.pow(10, precision)) / Math.pow(10, precision);
    },
    countDecimals: function (value) {
        value = parseFloat(value)
        if (Math.floor(value) === value) return 0;
        return value.toString().split(".")[1].length || 0;
    },
    isEmpty: function (value) {
      return  value != "0" && (value == "" || value == null);
    }
}
